import React, { useEffect, useState } from "react";

import {
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Spinner,
  IconButton,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";

import info_icon from "../../assets/images/icons/info_icon.svg";
import my_suppliers_search_icon from "../../assets/images/icons/my_suppliers_search_icon.svg";
import dot_verticle_icon from "../../assets/images/icons/dots-vertical_icon.png";

import { useNavigate } from "react-router-dom";
import useDocumentTitle from "hooks/useDocumentTitle";

import GetCurrentUserSuppliers from "services/GetCurrentUserSuppliers";

import formatDate from "utils/utils";
import TablePagination from "components/TablePagination/TablePagination";
import SupplierFilterModal from "./SupplierFilterModal";

import data_not_found_blue_icon from "assets/images/icons/general_icons/data_not_found_blue_icon.png";
import monitor_rulebook from "../../assets/images/icons/general_icons/monitor_rulebook.png";

import FavouriteSupplier from "./Components/FavouriteSupplier/FavouriteSupplier";

const sort_last_updated_selector_data = [
  {
    value: "ASC",
    label: "Oldest First",
  },
  { value: "DSC", label: "Newest First" },
];

export default function Supplier() {
  useDocumentTitle("My Suppliers");

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  // use states
  const [supplierDetails, setSuppliersDetails] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortByLastUpdated, setSortByLastUpdated] = useState("DSC");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const navigate = useNavigate();

  const navigateToSupplierDetail = (data, defaultTab) => {
    navigate(data.supplier_id, {
      state: { data: data, default_tab: defaultTab },
    }); // Step 3: Use navigate function
  };

  useEffect(() => {
    // Reset the current page to 0 when the search term changes
    setCurrentPage(0);
  }, [searchTerm]);

  useEffect(() => {
    const getSuppliers = async () => {
      setIsLoading(true);

      const params = {
        page_size: pageSize,
        page_number: currentPage,
        search: searchTerm,
        suppliers_order: sortByLastUpdated,
      };

      const response_suppliers_data = await GetCurrentUserSuppliers(params);

      setTotalPages(response_suppliers_data.data.pages);
      setTotalRecords(response_suppliers_data.data.total_records);

      setSuppliersDetails(response_suppliers_data.data.data);

      setIsLoading(false);
    };

    const debounce = setTimeout(() => {
      getSuppliers();
    }, 500);
    return () => clearTimeout(debounce);
  }, [currentPage, pageSize, searchTerm, sortByLastUpdated]);

  return (
    <div className="">
      <Stack spacing={"35px"}>
        <div>
          <h1 className="font-raleway  ">My Suppliers </h1>
          <div className="  secondary-background-accent-color mt-4 py-1 px-2  flex flex-row gap-3 ">
            <div className="h-full flex flex-col justify-center">
              <img src={info_icon} alt="information icon" />
            </div>
            <p className="secondary-text-accent-color-dark">
              Click on the supplier to view details
            </p>
          </div>
        </div>
        {/* {isLoading && <Loading />} */}
        <SupplierFilterModal
          isOpen={isOpen}
          onClose={onClose}
          setsetSearchTermProp={setSearchTerm}
          setSortByLastUpdatedProp={setSortByLastUpdated}
        />
        <div className="flex flex-col  ">
          <div className="h-full border primary-border-color  ">
            <div className=" flex flex-row justify-between ">
              <div className="md:flex flex-col  w-80 mr-2 hidden  ">
                <InputGroup size="lg">
                  <InputLeftElement
                    sx={{ paddingTop: "25px" }}
                    pointerEvents="none"
                  >
                    <img src={my_suppliers_search_icon} alt="search icon" />
                  </InputLeftElement>
                  <Input
                    variant="unstyled"
                    placeholder="Search Supplier with Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      width: "100%",
                      fontSize: { base: "16px", sm: "12px", xs: "10px" },
                      fontcolor: "#00000099",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="flex lg:hidden  flex-col justify-center mr-2  ">
                <IconButton
                  variant="ghost"
                  icon={<img src={dot_verticle_icon} alt="menu" />}
                  sx={{
                    width: "40px",
                    height: "40px",
                    justifyContent: "center",
                  }}
                  onClick={onOpen}
                />
              </div>

              <div className="flex flex-row gap-5 max-lg:hidden">
                <div className="flex flex-col justify-center table-heading ">
                  <div>Sort By</div>
                  <div>Last Updated</div>
                </div>
                <div className="w-40 flex flex-col justify-center mr-2  ">
                  <Select
                    size="lg"
                    variant="outlineCustom"
                    onChange={(e) => setSortByLastUpdated(e.target.value)}
                    value={sortByLastUpdated}
                  >
                    {sort_last_updated_selector_data.map((data, index) => {
                      return (
                        <option key={index} value={data.value}>
                          {data.label}
                        </option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </div>
          </div>
          {isLoading && (
            <div className="flex flex-row justify-center   h-[34rem] ">
              <Spinner className="my-auto" size="xl" />
            </div>
          )}

          <div className="overflow-x-auto   max-h-[34rem]  overflow-y-auto  ">
            {!isLoading && (
              <>
                <table className=" w-full  border border-[#e9e9e9] table-auto">
                  <thead>
                    <tr className="bg-[#e9e9e9] h-[2.63rem]">
                      <th></th>

                      <th className="pl-1 py-1.5  ">
                        <p className="table-heading">Name</p>
                      </th>
                      <th className="py-1.5 table-heading  max-w-60 xl:max-w-xl">
                        URL
                      </th>
                      <th className="py-1.5 table-heading-center">
                        Monitor Rulebook
                      </th>
                      <th className="py-1.5 table-heading">Last Checked</th>
                      <th className="py-1.5 table-heading">Last Updated</th>
                    </tr>
                  </thead>
                  <tbody className=" ">
                    {supplierDetails?.map((data, index) => {
                      const fav = data.is_favourite;
                      const user_supplier_id = data.user_suppliers_id;
                      data = data.supplier;
                      return (
                        <tr
                          className="border-x primary-border-color hover:bg-gray-100 hover:cursor-pointer group h-[3.13rem] "
                          onClick={() => {
                            navigateToSupplierDetail(data, 0);
                          }}
                          key={index}
                        >
                          <td
                            className="pl-3 "
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <FavouriteSupplier
                              is_favourite={fav}
                              supplierName={data?.supplier_name}
                              user_supplier_id={user_supplier_id}
                            />
                          </td>
                          <td className="pl-2 py-2.5 max-w-xs truncate   group-hover:underline h-full ">
                            <Tooltip label={data.supplier_name}>
                              <p className="table-text">{data.supplier_name}</p>
                            </Tooltip>
                          </td>
                          <td className="table-text-light truncate  max-w-60 xl:max-w-lg">
                            <Tooltip label={data?.supplier_url}>
                              {data?.supplier_url?.length > 50
                                ? `${data?.supplier_url.slice(0, 60)}......`
                                : data?.supplier_url}
                            </Tooltip>
                          </td>
                          <td className="text-center ">
                            <IconButton
                              variant="ghost"
                              icon={
                                <img
                                  src={monitor_rulebook}
                                  alt="monitor rulebok icon"
                                />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                navigateToSupplierDetail(data, 1);
                              }}
                            />
                          </td>
                          <td className="table-text-light">
                            {formatDate(data.last_checked)}
                          </td>
                          <td className="table-text-light">
                            {formatDate(data.last_modified)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
          </div>
          {!supplierDetails?.length && !isLoading && (
            <div className="flex flex-row justify-center h-[32rem]    ">
              <div className="my-auto flex flex-row justify-center gap-2 ">
                <img src={data_not_found_blue_icon} alt="data not found icon" />
                <p>Data Not Found</p>
              </div>
            </div>
          )}
          <TablePagination
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </Stack>
    </div>
  );
}
